// Métadonnées du composant EmptyCell
import type { ComponentMetadata } from '../../G&CSCM/Core/types';

export const EmptyCellConfig: ComponentMetadata = {
    name: 'EmptyCell',
    displayName: 'Cellule Vide',
    description: 'Cellule vide pour créer des espaces dans la grille',
    category: 'Layout',
    defaultParams: {},
    paramDefinitions: {},
    outsideGrid: false,
    defaultEnabled: true
};

export default EmptyCellConfig;




